import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap flex-none gap-6 items-center p-6 text-zinc-100 bg-zinc-900 lg:flex-row lg:flex-nowrap lg:pl-36 flex-column" }
const _hoisted_2 = { class: "px-6 text-xs font-bold lg:shrink lg:px-0 lg:text-base" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex grow gap-6 justify-center items-center lg:flex-row lg:flex-none lg:ml-auto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/iso.svg",
    alt: "ISO",
    class: "h-12 lg:h-24"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/sert.svg",
    alt: "РСТ",
    class: "h-12 lg:h-24"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/torg.svg",
    alt: "ТПП РФ",
    class: "h-12 lg:h-24"
  })
], -1)


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const year = new Date().getFullYear();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Государственный центр технических исследований " + _toDisplayString(_unref(year)) + " г. | Лицензия от 10.11.2010 г. ", 1),
    _hoisted_3
  ]))
}
}

})